var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "account-orders" },
    [
      _c("h2", [_vm._v("Оформленные заказы")]),
      _vm.ORDERS.length
        ? _c(
            "div",
            { staticClass: "orders" },
            [
              _c("vue-client-only", [
                !_vm.adaptive.isMobile
                  ? _c("div", { staticClass: "legend" }, [
                      _c("div", { staticClass: "number" }, [
                        _vm._v("\n          Заказ\n        ")
                      ]),
                      _c("div", { staticClass: "status" }, [
                        _vm._v("\n          Статус\n        ")
                      ]),
                      _c("div", { staticClass: "delivery" }, [
                        _vm._v("\n          Доставка\n        ")
                      ]),
                      _c("div", { staticClass: "payment" }, [
                        _vm._v("\n          Оплата\n        ")
                      ]),
                      _c("div", { staticClass: "price price-rub" }, [
                        _vm._v("\n          Сумма\n        ")
                      ])
                    ])
                  : _vm._e()
              ]),
              _vm._l(_vm.ORDERS, function(order) {
                return _c("order-item", {
                  key: order.id,
                  attrs: { order: order },
                  on: { choose: _vm.openOrder }
                })
              })
            ],
            2
          )
        : _c(
            "page-info",
            {
              staticClass: "page-info",
              attrs: { title: "Вы пока не оформили ни одного заказа" }
            },
            [
              _vm._v(
                "\n    Чтобы оформить заказ, добавьте товары в корзину или перейдите в каталог\n    "
              ),
              _c(
                "a",
                { attrs: { href: "/" } },
                [
                  _c("ui-button", {
                    staticClass: "button",
                    attrs: { text: "Начать покупки" }
                  })
                ],
                1
              )
            ]
          ),
      _vm.ORDERS.length && !_vm.END
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "reached",
                  rawName: "v-reached",
                  value: _vm.load,
                  expression: "load"
                }
              ],
              staticClass: "loader"
            },
            [
              _c(
                "transition",
                { attrs: { name: "fade" } },
                [
                  _vm.PROGRESS
                    ? _c("ui-loader", { attrs: { size: "60" } })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "order-support",
        { staticClass: "hint" },
        [
          _vm.ORDERS.length
            ? [
                _vm._v(
                  "\n      Если вы хотите отказаться от заказа, объединить несколько заказов или изменить данные обращайтесь в службу поддержки пользователей FUNDAY по почте "
                ),
                _c("a", { attrs: { href: "mailto:helpme@fundayshop.com" } }, [
                  _vm._v("helpme@fundayshop.com")
                ]),
                _vm._v(" или по телефону "),
                _c("a", { attrs: { href: "tel:+78007700101" } }, [
                  _vm._v("8 800 770-01-01")
                ]),
                _vm._v(" (по России бесплатно), с 7:00 до 22:00 (мск)\n    ")
              ]
            : [
                _vm._v(
                  "\n      С вопросами обращайтесь в службу поддержки пользователей FUNDAY по почте "
                ),
                _c("a", { attrs: { href: "mailto:helpme@fundayshop.com" } }, [
                  _vm._v("helpme@fundayshop.com")
                ]),
                _vm._v(" или по телефону "),
                _c("a", { attrs: { href: "tel:+78007700101" } }, [
                  _vm._v("8 800 770-01-01")
                ]),
                _vm._v(" (по России бесплатно), с 7:00 до 22:00 (мск)\n    ")
              ]
        ],
        2
      ),
      _c("order-popup")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }